import React, { useEffect, useState } from 'react'
import { CheckSquareFilled } from '@ant-design/icons'
import styles from './index.module.less'
import classNames from 'classnames'
import defaultImg from 'app/assets/images/default.png'

interface ItemProps {
  imgSrc?: string
  label?: string
  checked?: boolean
  onChange?: (status?: boolean) => void
  disable?: boolean
}

export default function Item({
  imgSrc,
  checked,
  onChange,
  label,
  disable,
}: ItemProps) {
  const [activate, setActivate] = useState<boolean | undefined>(false)

  useEffect(() => {
    setActivate(checked)
  }, [checked])

  return (
    <div
      className={classNames(
        styles.item,
        activate && styles.activate,
        disable && styles.disable
      )}
      onClick={() => {
        if (disable) return
        setActivate(!activate)
        onChange?.(!activate)
      }}
    >
      <img src={imgSrc || defaultImg} alt="" />
      <span>{label}</span>
      {activate && <CheckSquareFilled className={styles.icon} />}
    </div>
  )
}
